import React from 'react';

const VisionMission = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Vision & Mission</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Our guiding principles</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row g-5">
          <div className="col-12 col-md-6">
            <div className="card border-0 shadow h-100 p-4 rounded-4">
              <div style={{ fontSize: 50 }} className="mb-3">🔭</div>
              <h3 className="fw-bold text-primary">Our Vision</h3>
              <p className="text-muted">To be the most trusted and innovative technology partner for businesses worldwide, enabling digital transformation that creates lasting value and competitive advantage.</p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card border-0 shadow h-100 p-4 rounded-4">
              <div style={{ fontSize: 50 }} className="mb-3">🎯</div>
              <h3 className="fw-bold text-primary">Our Mission</h3>
              <p className="text-muted">To empower businesses with cutting-edge technology solutions that drive growth, efficiency, and innovation — delivering excellence through integrity, expertise, and a customer-first approach.</p>
            </div>
          </div>
        </div>

        <div className="row g-4 mt-4">
          {[{ icon: '💡', title: 'Innovation', desc: 'Continuously pushing boundaries with emerging technologies.' }, { icon: '🤝', title: 'Integrity', desc: 'Building trust through transparency and honest partnerships.' }, { icon: '🎯', title: 'Excellence', desc: 'Delivering the highest quality in every project.' }, { icon: '🌍', title: 'Global Reach', desc: 'Serving clients across 15+ countries worldwide.' }].map((v, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 bg-light h-100 p-3 text-center">
                <div style={{ fontSize: 36 }} className="mb-2">{v.icon}</div>
                <h6 className="fw-bold">{v.title}</h6>
                <p className="text-muted small mb-0">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default VisionMission;
